
export const handleProductUrl = url => {
	url = url.trim();
	const skuId = url.match(/skuid=\d+/) || url.match(/skuId=\d+/);
	const sku_properties = skuId ? `&${skuId[0]}` : '';
	if (/yangkeduo.com/.test(url) && url.indexOf("goods_id") != -1) {
		const goods_id = url.match(/goods_id=\d+/)[0];
		return `${url.split('?')[0]}?${goods_id}${sku_properties}`;
	} else if (/suning.com/.test(url)) {
		const id = url.match(/\d+\/\d+/)[0];
		return `https://product.suning.com/${id}.html${sku_properties}`
	} else if (/detail.tmall.hk/.test(url) || /tmall.com/.test(url) || /yao.95095.com/.test(url) || /item.taobao.com/.test(url)) {
		// const id = url.match(/id=\d+/)[0];
		var reg = new RegExp("(^|&|[?])id=([^&]*)(&|$)");
		var regs = new RegExp("(^|&|[?])itemid=([^&]*)(&|$)");
		var r = url.substr(1).match(reg) || url.substr(1).match(regs);
		var newName = r != null ? r[2] : "";
		console.log(newName)
		return `${url.split('?')[0]}?id=${newName}${sku_properties}`;
	} else if (/jd.com/.test(url)) {
		const idHtmlStr = url.match(/\d+\.html/)[0];
		return `https://item.jd.com/${idHtmlStr}${sku_properties}`
	} else if (/1688.com/.test(url)) {
		if (url.indexOf('skuid') != -1) {
			return `${url}`;
		}
		if (/\?/.test(url)) {
			return `${url.split('?')[0]}${sku_properties}`
		} else {
			return `${url}${sku_properties}`;
		}
	} else if (/product.dangdang.com/.test(url)) {
		if (skuId && skuId.length > 0) {
			let ddUrl = url.substring(0, url.indexOf('html') + 4) + '?' + skuId[0]
			return `${ddUrl}`;
		} else {
			let ddUrl = url.substring(0, url.indexOf('html') + 4)
			return `${ddUrl}`;
		}
	} else if (/hema.taobao.com/.test(url)) {
		return `${url}`
	} else if (/haohuo.jinritemai.com/.test(url)) {
		return `${url}`
	} else {
		return `${url}${sku_properties}`;
	}
}
//平台转名字
export const platformtoarr = (arr) => {
	let f = [
		{
			name: '抖音',
			platform: 'DY',
		}, {
			name: '盒马',
			platform: 'HM',
		}, {
			name: '淘宝网',
			platform: 'TB',
		}, {
			name: '天猫商城',
			platform: 'TM',
		}, {
			name: '京东商城',
			platform: 'JD',
		}, {
			name: '苏宁易购',
			platform: 'SN',
		}, {
			name: '国美在线',
			platform: 'GM',
		}, {
			name: '拼多多',
			platform: 'PDD',
		}, {
			name: '亚马逊',
			platform: 'AMAZON',
		}, {
			name: '唯品会',
			platform: 'WPH',
		}, {
			name: '药房网',
			platform: 'YFW',
		}, {
			name: '1药城',
			platform: 'YYC',
		}, {
			name: '1688',
			platform: '1688',
		}, {
			name: '速卖通',
			platform: 'SMT',
		}, {
			name: '其他',
			platform: 'platform_OTHER',
		}, {
			name: '当当网',
			platform: 'DD',
		}, {
			name: '闲鱼',
			platform: 'XY',
		}, {
			name: '阿里零售通',
			platform: 'ALST',
		}, {
			name: '1号店',
			platform: '1HD',
		}, {
			name: '云集',
			platform: 'YJWD',
		}, {
			name: '邮乐网',
			platform: 'YLW',
		}, {
			name: '微信',
			platform: 'WECD',
		}, {
			name: '蘑菇街',
			platform: 'MGJ',
		}, {
			name: '聚美优品',
			platform: 'JMYP',
		}, {
			name: '楚楚街',
			platform: 'CCJ',
		}, {
			name: '贝贝网',
			platform: 'BBWG',
		},
		{
			name: '淘宝天猫',
			platform: 'TBTM'
		},
		{
			name: 'lazada-越南',
			platform: 'LZDVN',
		},
		{
			name: 'lazada-新加坡',
			platform: 'LZDSG',
		},
		{
			name: 'lazada-马来西亚',
			platform: 'LZDMY',
		},
		{
			name: '小红书',
			platform: 'XHS',
		}
	];
	let plaArr = []
	arr.forEach(item => {
		f.forEach(items => {
			if (item === items.platform) {
				plaArr.push(items)
			}
		})
	})
	return plaArr
}
//根据平台获取itemid
export const getItemId = (str) => {
	console.log(str)
	let result = ''
	if (str.indexOf("item.taobao.com") != -1 || str.indexOf("detail.tmall.com") != -1 || str.indexOf("yao.95095.com") != -1 || /detail.tmall.hk/.test(str) || /detail.liangxinyao/.test(str)) {
		var reg = new RegExp("(^|&|[?])id=([^&]*)(&|$)");
		var regs = new RegExp("(^|&|[?])itemid=([^&]*)(&|$)");
		var r = str.substr(1).match(reg) || str.substr(1).match(regs);
		result = r != null ? r[2] : "";
	} else if (str.indexOf("item.jd.com") != -1 || /yiyaojd.com/.test(str)) {
		result = str.slice(str.indexOf('.com/') + 5, str.indexOf('.html'))
	}
	else if (/item.jd.hk/.test(str)) {
		result = str.slice(str.indexOf('jd.hk') + 6, str.indexOf('.html'))
	}
	else if (/item.jkcsjd.com/.test(str)) {
		result = str.slice(str.indexOf('jkcsjd.hk') + 25, str.indexOf('.html'))
	}
	else if (str.indexOf("product.suning.com") != -1) {
		result = str.slice(str.indexOf('.com/') + 5, str.indexOf('.html'))
	}
	else if (str.indexOf("mobile.yangkeduo.com") != -1 || str.indexOf("app.yangkeduo.com") != -1 || str.indexOf("yangkeduo.com") != -1) {
		console.log(str)
		if (str.indexOf("&skuid") != -1) {
			var skuid = str.split('?')[1].split('&')[1]
			var reg = new RegExp("(^|&|[?])goods_id=([^&]*)(&|$)");
			result = str.substr(1).match(reg)[2] + "&" + skuid
		} else if (str.indexOf("ps=") != -1) {
			console.log(123123123)
			result = '111111'
		} else {
			var reg = new RegExp("(^|&|[?])goods_id=([^&]*)(&|$)");
			result = str.substr(1).match(reg)[2]
		}
	}
	else if (str.indexOf("detail.1688.com/") != -1) {
		if (str.split("/offer/")[1]) {
			var newStr = str.split("/offer/")[1]
			result = newStr.split(".html")[0]
		}
	}
	else if (str.indexOf("product.dangdang.com/") != -1) {
		var newStr = str.split(".com/")[1]
		result = newStr.split(".html")[0]
	}
	else if (str.indexOf("www.yaofangwang.com/medicine/") != -1) {
		var newStr = str.split("/medicine/")[1]
		result = newStr.split(".html")[0]
	}
	else if (str.indexOf("detail.vip.com/detail-") != -1) {
		var newStr = str.split("detail.vip.com/detail-")[1]
		result = newStr.split(".html")[0]
	}
	else if (str.indexOf("m.tb.cn") != -1) {
		result = '111111'
	}
	else if (str.indexOf("e.tb.cn") != -1) {
		result = '111111'
	}
	else if (str.indexOf("//3.cn/") != -1) {
		result = '111111'
	}
	else if (str.indexOf("mall.yaoex.com") != -1) {
		result = str.split("spuCode/")[1]
	}
	else if (str.indexOf("www.lazada.vn") != -1) {
		result = str.split("products/")[1].split(".html")[0]
	}
	else if (str.indexOf("www.lazada.sg") != -1) {
		result = str.split("products/")[1].split(".html")[0]
	}
	else if (str.indexOf("www.lazada.com.my") != -1) {
		result = str.split("products/")[1].split(".html")[0]
	}
	else if (str.indexOf("hema.taobao.com") != -1) {
		console.log(str)
		result = str
	}
	else if (str.indexOf("haohuo.jinritemai.com") != -1) {
		console.log(str)
		result = str
	}
	else if (str.indexOf("xiaohongshu") != -1) {
		console.log(str)
		result = str
	}
	console.log(result)
	return result
}
//获取地址中参数
export const getUrlParam = (url, name) => {
	var reg = new RegExp("(^|&|[?])" + name + "=([^&]*)(&|$)")
	var r = url.match(reg)
	var newName = (r != null ? r[2] : "")
	return newName
}
//获取skuid
export const getUrlSkuId = (url) => {
	console.log(url)
	let name = /skuId/.test(url) ? 'skuId' : 'skuid'
	var reg = new RegExp("(^|&|[?])" + name + "=([^&]*)(&|$)")
	var r = url.match(reg)
	var newName = (r != null ? r[2] : "")
	return newName
}

//根据链接获取平台
export const linktoplatform = (link) => {
	let f = [
		{
			url: 'item.taobao.com',
			platform: 'TB',
		}, {
			url: 'm.tb.cn',
			platform: 'TB',
		}, {
			url: 'e.tb.cn',
			platform: 'TB',
		}, {
			url: 'detail.tmall',
			platform: 'TM',
		}, {
			url: 'item.jd.com',
			platform: 'JD',
		}, {
			url: '//3.cn/',
			platform: 'JD',
		}, {
			url: 'product.suning.com',
			platform: 'SN',
		}, {
			url: 'mobile.yangkeduo.com',
			platform: 'PDD',
		}, {
			url: 'app.yangkeduo.com',
			platform: 'PDD',
		}, {
			url: 'yangkeduo.com',
			platform: 'PDD',
		}, {
			url: 'detail.1688.com',
			platform: '1688',
		}, {
			url: 'product.dangdang.com',
			platform: 'DD',
		}, {
			url: 'yaofangwang.com',
			platform: 'YFW',
		}, {
			url: 'mall.yaoex.com',
			platform: 'YYC',
		}, {
			url: 'vip.com',
			platform: 'WPH',
		}, {
			url: 'www.lazada.vn',
			platform: 'LZDVN',
		},
		{
			url: 'www.lazada.sg',
			platform: 'LZDSG',
		},
		{
			url: 'www.lazada.com.my',
			platform: 'LZDMY',
		},
		{
			url: 'hema.taobao.com',
			platform: 'HM',
		},
		{
			url: 'haohuo.jinritemai.com',
			platform: 'DY',
		},
		{
			url: 'haohuo.jinritemai.com',
			platform: 'DY',
		},
		{
			url: 'xiaohongshu',
			platform: 'XHS',
		},
		{
			url: 'xhs',
			platform: 'XHS',
		}];
	let platform = '';
	f.map(item => {
		if (link.indexOf(item.url) !== -1) {
			platform = item.platform
		}
	})
	return platform;
}
//判断是否是申诉合理
export const ifEvaluate = (flowList) => {
	if (flowList.length > 2) {
		if (
			flowList[flowList.length - 2].status === 5 &&
			flowList[flowList.length - 1].status === 7
		) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
}
